import { Auth0Client } from "@auth0/auth0-spa-js";
import { auth0Config } from "../config";

export const auth0Client = typeof window !== "undefined"
  ? new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    })
  : (null as unknown as Auth0Client);
